<template>
  <div id="telaPrincipal">
    <div class="container my-2">
      <!-- Mensagens de Sucesso e Erro -->
      <!-- <mensagemAlerta :mensagens="mensagemSucesso" />
      <mensagemAlerta :mensagens="mensagemErro" />    -->
        <div v-if="mensagemSucesso">
            <div v-for="i in mensagemSucesso" :key="i">
            <b-alert show variant="success" dismissible>
                <b-icon variant="success" icon="check" />
                {{ i }}
            </b-alert>
            </div>
        </div>

        <div v-if="mensagemErro">
            <div v-for="i in mensagemErro" :key="i">
            <b-alert show variant="danger" dismissible>
                <b-icon variant="danger" icon="x-circle-fill" />
                {{ i }}
            </b-alert>
            </div>
        </div>       
      <!-- -->
      <h2 class="title">Reemitir Guia</h2>         
      <div style="text-align: center">
        <loading :active.sync="carregando" :is-full-page="true"></loading>
      </div>      
      <div v-if="logadoGovBr">
        <form @submit.prevent>
          <b-card class="mb-4">
            <!-- Formulário de Contribuinte -->
            <formResponsavelEmpresa :responsavel="contribuinte" :cnpj="cnpj" />
            <!-- -->          
          </b-card>  
          <b-card>
            <a id="ancora-guia"></a>
            <tabelaListagemCNPJ
              :rows="cnpjsRelacionadosTabela"
              :forca-limpar-campos="forcaLimparCamposListagemCnpj"
              @update:selecionado="handleCnpjTabelaSelecionado"
            />

            <b-row class="float-right mt-3 mr-3">
              <b-col sm="6">
                <b-button variant="outline-secondary" @click="limpar"
                  >Limpar</b-button
                >
              </b-col>
              <b-col sm="6">
                <b-button
                  variant="primary"
                  @click="pesquisarGuiasRelacionadas"
                  :disabled="!cnpjRelacionadoFoiSelecionado"
                  >Pesquisar</b-button
                >
              </b-col>
            </b-row>
          </b-card>

          <div v-if="tabelaGuiasSelecionadas.length > 0">
            <a id="ancora-guias"></a>
            <b-card class="my-3">
              <div>
                <tabelaGuiasSelecionadas
                  :items="tabelaGuiasSelecionadas"
                  @update:guiaSelecionada="dadosGuiaSelecionada"
                />
              </div>
              <b-row class="float-right mt-3 mr-3">
                <b-col sm="6">
                  <b-button variant="outline-secondary" @click="limpar"
                    >Limpar</b-button
                  >
                </b-col>
                <b-col sm="6">
                  <b-button
                    variant="primary"
                    @click="emitirGuia"
                    :disabled="!idGuiaSelecionada"
                    >Emitir</b-button
                  >
                </b-col>
              </b-row>
            </b-card>
          </div>
        </form>
      </div>
      <div v-else>
        <form @submit.prevent>
          <div class="">
            <b-card>
            <b-card class="ml-0" style="width: 100%">
              <span
                class="title h5"
                v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Pesquisar empresas ligadas ao CPF."
              >
                Dados do contribuinte
                <b-icon
                  variant="primary"
                  icon="info-circle-fill"
                  class="ml-2"
                />
              </span>

              <b-row class="mb-3 mt-4">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="3" md="3" clas="ml-2" lg="1" align-self="center">
                  <label for="cpf" class="pb-3">CNPJ</label>
                </b-col>
                <b-col sm="8" md="4" class="ml-4" align-self="start">
                  <b-form-input
                    id="cpfCnpj"
                    class="ml-0"
                    v-mask="['XX.XXX.XXX/XXXX-##']"
                    v-model="CNPJinformado"
                    @keyup="validacaoCNPJ()"
                  >
                  </b-form-input>
                  <small
                    id="cpfCnpj"
                    :class="erroValidacaoCNPJ"
                    class="ml-3 form-text"
                  >
                    {{ mensagemValidacaoCNPJ }}
                  </small>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="0" md="0"> </b-col>
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="0" align-self="end" style="padding-rigth=0px">
                  <label for="NomeFantasia">Nome Fantasia</label>
                </b-col>
                <b-col sm="8" style="padding-left=0px" align-self="start">
                  <b-form-input id="NomeFantasia" class="ml-2" disabled v-model="cnpj.nome">
                  </b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1 mt-3 float-right">
                <b-col sm="4" class="mr-3">
                  <b-button variant="outline-secondary" @click="limparCNPJ">
                    Limpar
                  </b-button>
                </b-col>
                <b-col sm="7">
                  <b-button
                    variant="primary"
                    :disabled="!preencheCnpjOK"
                    @click="pesquisarGuiasRelacionadas()"
                  >
                    Pesquisar
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
            </b-card>
          <div v-if="tabelaGuiasSelecionadas.length > 0">
            <a id="ancora-guias"></a>
            <b-card class="my-3">
              <div>
                <tabelaGuiasSelecionadas
                  :items="tabelaGuiasSelecionadas"
                  @update:guiaSelecionada="dadosGuiaSelecionada"
                />
              </div>
              <b-row class="float-right mt-3 mr-3">
                <b-col sm="6">
                  <b-button variant="outline-secondary" @click="limpar"
                    >Limpar</b-button
                  >
                </b-col>
                <b-col sm="6">
                  <b-button
                    variant="primary"
                    @click="emitirGuia"
                    :disabled="!idGuiaSelecionada"
                    >Emitir</b-button
                  >
                </b-col>
              </b-row>
            </b-card>
          </div>            
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import tabelaListagemCNPJ from "../components/compartilhados/tabelaListagemCNPJ.vue";
import tabelaGuiasSelecionadas from "../components/tabelaGuiasSelecionadas.vue";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";
// import validarCNPJ from "../validations";
import { validarCNPJ } from '@at-siatu-tributario/tipo-identificador';
// import mensagemAlerta from "../components/mensagemAlerta.vue";
import formResponsavelEmpresa from "../components/formResponsavelEmpresa.vue";

export default {
  components: {
    loading,
    tabelaListagemCNPJ,
    tabelaGuiasSelecionadas,
    // mensagemAlerta, 
    formResponsavelEmpresa,
 
  },
  directives: {
    mask,
  },
  data() {
    return {
      carregando: false,
      mensagemSucesso: [],
      mensagemErro: [],
      mensagemISSQNFonte:
        "ISSQN Fonte - Não retido - Atenção: Essa modalidade de parcelamento é restrita às hipóteses de retenção descritas no Art. 21, Lei Municipal nº 8.725/2003",

      guiaSelecionada: "",
      listaCNPJRelacionado: [],

      existeCnpjRelacionado: false,

      inscricaoMunicipal: [],
      listaInscricaoMunicipal: [],
      selectAllRows: false,
      forcaLimparCamposListagemCnpj: false,

      idGuiaSelecionada: "",

      contribuinte: {
        cpf: "",
        nome: "",
        inscricaoMunicipal: "",
        idPessoa: "",
        idPessoaPapel: "",
      },
      logadoGovBr: false,
      tabelaGuiasSelecionadas: [],
      guiaFoiSelecionada: false,
      cnpjRelacionadoFoiSelecionado: false,
      cnpjsRelacionadosTabela: [],

      CNPJinformado: "",
      mensagemValidacaoCNPJ: "",
      erroValidacaoCNPJ: "",
      preencheCnpjOK: false,

      cnpj: {
        valor: "",
        nome: "",
      },
    };
  },
  computed: {
    desabilitarPesquisar() {
      return this.guiaSelecionada === "";
    },
  },
  async beforeCreate() {
    const logado =
      this.$store.getters.userInfo.origem === "GovBr" ||
      this.$store.getters.userInfo.origem === "AD";
    if (!logado) this.$router.push({ name: "Home" });
  },
  async beforeMount() {
    this.logadoGovBr = this.$store.getters.userInfo.origem === "GovBr";
    if (this.logadoGovBr) {
      this.contribuinte.cpf = this.$store.getters.userInfo.preferred_username;
      this.contribuinte.nome = this.$store.getters.userInfo.name;

      await this.buscarCNPJRelacionados();
    }
  },
  watch: {
      CNPJinformado(newValue) {
          if (newValue.length !== 18) {
              this.tabelaGuiasSelecionadas = [];
          } 
      },
  },  
  methods: {
    limparCNPJ: function () {
      this.mensagemValidacaoCNPJ = "";
      this.CNPJinformado = "";
      this.cnpj.nome = "";
      this.listaInscricaoMunicipal = [];
      this.preencheCnpjOK = false;
      this.limpar();
    },

    validacaoCNPJ: function () {
      let tamCampo = 0;
      let txt = "";
      let formato = "";
      let tipo = this.CNPJinformado.length;

      this.preencheCnpjOK = false;

      //CPF
      if (tipo <= 18) {
        //CNPJ
        tamCampo = 18;
        txt = "CNPJ";
      }

      if (this.CNPJinformado.length <= tamCampo) {
        this.mensagemValidacaoCNPJ = txt + " digitado está incompleto";
        formato = "text-danger";
        this.preencheCpfdOK = false;
      }
      if (tipo == 18) {
        if (validarCNPJ(this.CNPJinformado)) {
          this.mensagemValidacaoCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCnpjOK = true;
        } else {
          this.mensagemValidacaoCNPJ = txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCnpjOK = false;
        }
      }
      this.erroValidacaoCNPJ = formato;

      if (this.CNPJinformado === "") {
        this.mensagemValidacaoCNPJ = "";
      }
    },

    toggleSelect() {
      this.selectAllRows = !this.selectAllRows;
      if (this.selectAllRows === true) this.selectAll();
      else this.clearAll();
    },

    clearAll() {
      this.selecionados.push(
        this.items.forEach((item) => {
          this.$set(item, "selecionado", false);
        })
      );
      this.emitirDados();
    },

    dadosGuiaSelecionada(dados) {
      this.idGuiaSelecionada = null;
      if (dados) this.idGuiaSelecionada = dados[0].idGuia;
    },

    async emitirGuia() {
      let argumento = "";
      try {
        await this.$axios
          .post(
            `${this.$env.url_backend}/v1/espontaneo/recupera-url-guia-termoConfissao`,
            {
              idGuia: this.idGuiaSelecionada,
            }
          )
          .then((response) => {
            argumento = response.data;
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
        window.scrollTo(0, 0);
      } finally {
        this.carregando = false;
      }
      const urlGuia = this.$env.url_cobranca + "/guia?idGuia=" + argumento;
      window.open(urlGuia, "_blank");
    },

    async pesquisarGuiasRelacionadas() {
      try {
        this.mensagemSucesso = [];
        this.mensagemErro = [];        
        this.carregando = true;
        this.limparMensagens();
        let cnpj = "";
        if (this.logadoGovBr) {
          cnpj = this.cnpjSelecionado;
        } else {
          cnpj = this.CNPJinformado.replace(/[^\d\w]+/g, "");
///
         const pTipoIdentificador = '4';
         const pIdentificador = cnpj;        
         await this.$axios
            .post(`${this.$env.url_backend}/v1/espontaneo/endereco-gov`, {
               pTipoIdentificador,
               pIdentificador
            })
            .then((response) => {
              const dados = response.data.resultado;           
              if (dados) {
                   this.cnpj.nome = dados.RAZAO_SOCIAL;   
              } else {
                   this.cnpj.nome = "";
              }
            });
///
        }

        await this.$axios
          .post(`${this.$env.url_backend}/v1/espontaneo/retorna-guias`, {
            cnpj,
          })
          .then((response) => {
            this.tabelaGuiasSelecionadas = response.data.guias;
          });
        ////se a ancora ancora-guia existir, rola a tela para ela
        const msAntesDeVerificarSeAncoraExiste = 300;
        setTimeout(() => {
          const ancoraSelecaoGuias = document.querySelector("#ancora-guias");
          if (ancoraSelecaoGuias) {
            ancoraSelecaoGuias.scrollIntoView({ behavior: "smooth" });
          }
        }, msAntesDeVerificarSeAncoraExiste);
        /// se não encontrar registro, exibe mensagem no topo da tela
        if (this.tabelaGuiasSelecionadas == 0) {
          this.mensagemSucesso.push("Nenhuma guia encontrada para este CNPJ.");
          window.scrollTo(0, 0);
        }
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
        window.scrollTo(0, 0);
      } finally {
        this.carregando = false;
      }
    },

    async buscarCNPJRelacionados() {
      try {
        this.carregando = true;
        this.mensagemErro = [];
        await this.$axios
          .get(`${this.$env.url_backend}/v1/espontaneo`)
          .then((response) => {
            const informacoesUsuario = response.data.informacoesUsuario;
            this.contribuinte.idPessoa = informacoesUsuario
              ? informacoesUsuario.ID_PESSOA
              : null;

            this.existeCnpjRelacionado = response.data.cnpjsRelacionados.listaEstabelecimento.length > 0;  
            this.cnpjsRelacionadosTabela =
              response.data.cnpjsRelacionados.listaEstabelecimento.map(
                (valor) => {
                  return {
                    cnpj: valor.cnpj,
                    cnpj_limpo: valor.cnpj.replace(/[^\d\w]+/g, ""),
                    nome: valor.nome,
                    selecionado: false,
                  };
                }
              );
              if (!this.existeCnpjRelacionado){
                        const mens =  "Não foi encontrado CNPJ relacionado para este CPF.";
                        this.mensagemErro.push(mens);
                        window.scrollTo(0, 0);            
                    }              
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
        window.scrollTo(0, 0);
      } finally {
        this.carregando = false;
      }
    },

    handleCnpjTabelaSelecionado(values) {
      if (!values || !values.dadosEstabelecimentoSelecionado) {
        return;
      }
      this.cnpjRelacionadoFoiSelecionado = true;
      this.desabilitaIdentificador = true;
      this.cnpjSelecionado =
        values.dadosEstabelecimentoSelecionado.codigoNacional;
    },

    handleGuiaTabelaSelecionado(values) {
      if (!values || !values.codigoNacional) {
        return;
      }
      this.guiaFoiSelecionada = true;
      this.desabilitaIdentificador = true;
      this.guiaSelecionada = values.codigoNacional;
    },

    emitirDRAM() {
      window.open(this.guiaEmitida.urlGuia, "_blank");
    },

    async limparMensagens() {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
    },

    async limpar() {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.forcaLimparCamposListagemCnpj = !this.forcaLimparCamposListagemCnpj;
      this.inscricaoMunicipal = {};
      this.listaInscricaoMunicipal = [];
      this.contribuinte.inscricaoMunicipal = "";
      this.listaReferencias = [];
      this.referencia = {
        id: 1,
        data: "",
        impostoDevido: "",
      };
      this.tabelaGuiasSelecionadas = [];
      this.cnpj = {
        valor: "",
        nome: "",
      };
      this.cnpjRelacionadoFoiSelecionado = false;
      this.guiaFoiSelecionada = false;
      this.CNPJinformado = "";
      this.mensagemValidacaoCNPJ = "";
      this.possuiAcaoFiscal = "";

      this.guiaSelecionada = "";
      this.tipoISSQN = "";
      this.mostrarErroDentroAcaoFiscal = false;
      this.mostrarErroForaAcaoFiscal = false;
    },
  },
};
</script>


<style></style>
